import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { Textarea } from "ui/components/textarea";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { surveySchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useCsatForm } from "./useCsatForm";
import { PermissionControlledInput } from "permissions/components/input";
import { FormLabel, FormSurveyCategoryQuestions } from "components/form";

const CsatForm = ({ surveyId }) => {
  const { jobId } = useParams();

  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead, requiredFields } =
    useCsatForm({
      surveyId,
      jobId,
    });

  return (
    <Form
      form={form}
      create={handleCreate}
      read={handleRead}
      update={handleUpdate}
      itemId={surveyId || "+"}
      schema={surveySchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        isUpdating,
        updateItem,
        isDirty,
      }) => (
        <div className="space-y-6">

          <FormField
            control={form.control}
            name="title"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="surveys"
                  field={field.name}
                  type="form"
                >
                  <FormLabel required={requiredFields.includes(field.name)}>
                    Title
                  </FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="questions"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="surveys"
                  field={field.name}
                  type="form"
                >
                  <FormSurveyCategoryQuestions
                    label="Select Categories"
                    value={field.value ?? []}
                    onChange={field.onChange}
                    error={form.formState.errors.questions}
                  />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(`/work/jobs/${jobId}/surveys`))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
          />
        </div>

      )}
    </Form>
  );
};

export default CsatForm;
